<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'progress'"
    class="page"
  >
    <Header
      :setting="{
        title: '看診進度',
        hasCancelMethod: true,
      }"
      @cancel="$router.push('/home')"
      class="mb6"
    />
    <div class="fs2 fw5 fc--primary mb6">
      {{ composable.member.info.clinic === '璟馨'
        ? '璟馨婦幼醫院' : '詠馨婦幼中心' }}
    </div>
    <div v-if="progress.length === 0">
      <div class="fs2 fw5 fc--primary mv6">
        目前尚未開診
      </div>
    </div>
    <div
      v-for="(shift, idx) in progress"
      :key="idx"
      @click="openReminder(shift)"
      class="section mb4"
    >
      <div class="column--central">
        <div v-if="shift.status === '看診中'">
          <div class="fs6 fw5 fc--primary mv1">
            {{ shift.currentNumber }}
          </div>
          <div class="fs1 fc--secondary mv1">
            目前號碼
          </div>
        </div>
        <div v-else>
          {{ shift.status }}
        </div>
      </div>
      <!-- <div class="column--central">
        <div class="row--central mv3">
          <div class="label bc--default ph3 pv1 mh1">
            {{ shift.division }} {{ shift.room }}
          </div>
        </div>
      </div> -->
      <div class="column--central">
        <div class="mv2 fs3">
          <div class="label bc--default ph0 pv1">
            {{ shift.division }}
          </div>
        </div>
        <div class="mv2 fs2">
          {{ shift.room }}
        </div>
      </div>
      <div class="column--central">
        <div class="row--central mv3 fs3 fw4">
          <div>{{ shift.doctor }}</div>
        </div>
        <div class="row--central mv1 fs2">
          醫師
        </div>
      </div>
      <div class="column--central">
        <div
          class="fs6 fw5 fc--primary mv1"
          v-if="shift.reminderNumber"
        >
          {{ shift.reminderNumber ?? '未設定' }}
        </div>
        <div
          class="fs1 fw2 fc--secondary mv1"
          v-else
        >
          未設定
        </div>
        <div class="fs1 fc--secondary mv1">
          提醒號碼
        </div>
      </div>
      <div class="column--central">
        <div
          class="circle circle--size-2 circle--secondary row--central"
        >
          <div
            class="fw4"
          >
            <font-awesome-icon
              :icon="['fas', 'bell']"
              v-if="shift.enable"
            />
            <font-awesome-icon
              :icon="['fas', 'bell-slash']"
              v-else
            />
          </div>
        </div>
      </div>
    </div>
    <div class="fs1">
      更新時間：{{ lastUpdateTime }}
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toHome="toHome"
  />

  <SettingModal
    v-if="isSetting"
    :shift="theShift"
    v-model:modelReminder="theReminder"
    @updateReminder="updateReminder"
    @close="isSetting=false"
  />
</template>

<script>
import {
  reactive, ref, onMounted, onUnmounted,
} from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import SettingModal from './components/SettingModal.vue';

export default {
  components: { SettingModal },

  setup() {
    const page = ref('initialization');
    const progress = ref([]);
    const reminders = ref([]);
    const isSetting = ref(false);
    const lastUpdateTime = ref('');
    const theShift = ref(null);
    const theReminder = reactive({
      enable: false,
      number: 0,
    });
    let refreshTimeout = null;

    const router = useRouter();
    onMounted(async () => {
      try {
        composable.loading.show('看診進度載入中');
        await getReminders();
        await getProgress();
        page.value = 'progress';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    onUnmounted(async () => {
      clearTimeout(refreshTimeout);
    });

    async function getProgress() {
      try {
        progress.value = await api.progress.get(composable.member);
        // 合併提醒號碼設定
        progress.value.forEach((p, idx) => {
          const match = reminders.value.find(
            (r) => r.doctor === p.doctor && r.room === p.room,
          );
          if (match) {
            progress.value[idx].reminderNumber = match.number;
            progress.value[idx].enable = match.enable;
          }
          // console.log('進度', idx, p, match);
        });
        // 定時更新看診進度
        lastUpdateTime.value = spiderman.moment().format('YYYY-MM-DD HH:mm:ss');
        console.log('看診進度', progress.value, lastUpdateTime.value);
        refreshTimeout = setTimeout(
          async () => { await getProgress(); }, 6000,
        );
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    async function getReminders() {
      try {
        reminders.value = await api.progressReminders.get(composable.member);
        console.log('看診提醒', reminders.value);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function openReminder(shift) {
      if (shift.status !== '看診中') {
        composable.modal.popup(`很抱歉，${shift.status}無法設定提醒。`);
        return false;
      }
      // composable.modal.popup('很抱歉，尚未開放提醒設定功能。');
      theShift.value = shift;
      theReminder.enable = shift.enable ?? false;
      theReminder.number = shift.reminderNumber ?? shift.currentNumber + 1;
      isSetting.value = true;
      return true;
    }

    async function updateReminder() {
      theReminder.number = theReminder.enable ? theReminder.number : 0;
      theReminder.division = theShift.value.division;
      theReminder.doctor = theShift.value.doctor;
      theReminder.room = theShift.value.room;

      try {
        composable.loading.show('設定中請稍候');
        const response = await api.progressReminders.update(
          composable.member, theReminder,
        );
        isSetting.value = false;
        console.log('設定提醒', theReminder, response);
        composable.modal.popup(response.message);
        await getReminders();
        await getProgress();
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        isSetting.value = false;
        composable.loading.close();
      }
    }

    function toHome() {
      composable.modal.close();
      router.push({ path: '/home' });
    }

    return {
      page,
      composable,
      isSetting,
      progress,
      lastUpdateTime,
      openReminder,
      theShift,
      theReminder,
      updateReminder,
      toHome,
    };
  },
};
</script>
